import http from '@/lib/http'
import { isUserTrialPrescriber } from '@/lib/permissions'
import { useUtilityStore } from '@/lib/stores/utils'
import type { Investigation } from '@/types/data'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

export const useGetInvestigations = (
  params?: Record<string, string>,
  options?: Omit<UseQueryOptions<Investigation[]>, 'queryFn' | 'queryKey'>
) => {
  return useQuery<Investigation[]>({
    queryKey: ['investigations'],
    queryFn: async () => {
      const result = (await http.get('/prescriber/investigations')) as Investigation[]

      if (isUserTrialPrescriber()) {
        const { actionedInvestigationIds } = useUtilityStore.getState()
        return result.filter(investigation => !actionedInvestigationIds.includes(investigation.id))
      }

      return result
    },
    ...options
  })
}
